/* eslint-disable @typescript-eslint/no-unused-vars */
import { ca } from '@cian/analytics';

interface ITrackNewbuildingPrizeBannerParams {
  event?: string;
  [key: string]: unknown;
}

export function trackNewbuildingPrizeBanner(params: ITrackNewbuildingPrizeBannerParams) {
  const { event: _event, ...eventParams } = params;

  ca('eventSite', {
    name: 'oldevent',
    ...eventParams,
  });
}
